import {
  createBrowserRouter,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { useEffect, useState } from "react";
import { useFunctionalityAccess } from "./Providers/FunctionalityAccessProvider";
import { FEATURE_CODES } from "./Services/functionalityAccess";
// import { lazy } from "react";
import Assessments from "./Pages/Assessments";
import AssessmentSaveProgress from "./Pages/AssessmentSaveProgress/index";
import AssessmentEncouragement from "./Pages/AssessmentEncouragement/index";
import AssessmentResult from "./Pages/AssessmentResult/index";
import Survey from "./Pages/Survey/index";
import Dashboard from "./Pages/Dashboard/Dashboard";
import ChatInterface from "./Pages/RelationShip/ChatInterface";
import LoginPage from "./Pages/Login";
import EmailInputPage from './Pages/Login/EmailInputPage';
import PhoneInputPage from './Pages/Login/PhoneInputPage';
import OtpVerificationPage from './Pages/Login/OtpVerificationPage';
import QRCodePage from './Pages/Login/QRCodePage';
import PaymentSuccessQRPage from './Pages/Login/PaymentSuccessQRPage';
import GuidedPlanBlockPage from './Pages/Login/GuidedPlanBlockPage';
import AppleCallbackPage from './Pages/Login/AppleCallbackPage';
import TermsofUse from "./Pages/TermsofUse";
import AboutAris from "./Pages/AboutAris";
import CookiePolicy from "./Pages/CookiePolicy";
import ManageRelationship from "./Pages/ManageRelationship";
import ShareAris from "./Pages/ShareAris";
import ShareInvite from "./Pages/ShareInvite";
import MyProfile from "./Pages/MyProfile";
import RelationshipProfile from "./Pages/RelationshipProfile";
import Onboarding from "./Pages/Onboarding";
// OnboardingV2 is deprecated - users complete onboarding via mobile app
import CustomerSupport from "./Pages/CustomerSupport/CustomerSupport";
import Settings from "./Pages/Settings";
import FaithSpirituality from "./Pages/FaithSpirituality";
import ConnectedHealth from "./Pages/ConnectedHealth";
import ConnectedHealthProvider from "./Pages/ConnectedHealth/ProviderDetail";
import MobilePhoneSettingsScreen2 from "./Pages/Settings/MobileScreens/MobilePhoneSettingsScreen2";
import MobilePhoneSettingsScreen3 from "./Pages/Settings/MobileScreens/MobilePhoneSettingsScreen3";
import EmailSettingPhoneScreen2 from "./Pages/Settings/EmailScreens/EmailSettingPhoneScreen2";
import EmailSettingPhoneScreen3 from "./Pages/Settings/EmailScreens/EmailSettingPhoneScreen3";
import NotificationSettings from "./Pages/Settings/Notifications/NotificationSettings";
import Communications from "./Pages/Settings/Communications/Communications";
import Loader from "./Pages/LoadingPage/DefaultLoader";
import ButtonLoader from "./Pages/LoadingPage/ButtonLoader";
import ErrorScreen from "./Pages/ErrorScreens";
import Feedback from "./Pages/FeedBack/Feedback";
// Dashboard view is provided by RelationShip's InitialChat
import ArisCoach from "./Pages/Coach";
import NewSurvey from "./Pages/NewSurvey/NewSurvey";
import NewConfirmation from "./Pages/NewConfirmation";
import CoachingHistory from "./Pages/CoachingHistory/CoachingHistory";
import ManageMembership from "./Pages/ManageMembership";
import ManageMembershipNew from "./Pages/ManageMembership/ManageMembershipNew";
import Logout from "./Pages/Logout";
import Success from "./Pages/Pricing/Success";
import Cancel from "./Pages/Pricing/Cancel";
import Elements from "./Pages/Elements";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import CorporateActivation from "./Pages/Corporate/Activation";
import CorporateSetup from "./Pages/Corporate/Setup";
import CorporateDone from "./Pages/Corporate/Done";
import UserActivation from "./Pages/RelationShip/Dialogues";
import cookies from "js-cookie";
import {
  getOnboardingRoute,
  isOnboardingComplete,
  isActivationPending,
  getCompletedStepsFromStorage,
} from "./Utils/onboardingNavigation";
import { confirmActivationState } from "./Utils/activationSync";
import BlueSvgBackground from "./Components/BlueSvgBackground";
import GradientBackground from "./Components/AddRelationshipHeaderGradient";
import WhiteBackground from "./Components/WhiteBackground";
import fcmService from "./Services/fcm";
import RootLayout from "./Components/RootLayout";
import amplitudeService from "./Services/amplitude";
// Dashboard functionality now handled by DashboardChat component
import VoiceHomeV2 from "./Pages/HomeV2/VoiceHome";
import KeyboardHomeV2 from "./Pages/HomeV2/KeyboardHome";
import HomeV2Router from "./Pages/HomeV2";
import CoachPrivateV2 from "./Pages/CoachV2/Private";
import DashboardChat from "./Pages/RelationShip/DashboardChat";
// Home sections — the three bottom tabs. "Aris" is /dashboard.
import Explore from "./Pages/Explore";
import Journey from "./Pages/Journey";
import JourneyMission from "./Pages/Journey/Mission";
import JourneyMissionEvolve from "./Pages/Journey/Mission/Evolve";
import JourneyMissionReview from "./Pages/Journey/Mission/Review";
import JourneyMissionHistory from "./Pages/Journey/Mission/History";
import JourneyMissionHistoryItem from "./Pages/Journey/Mission/HistoryItem";
import JourneyMomentum from "./Pages/Journey/Momentum";
import JourneyInsight from "./Pages/Journey/Insight";
import JourneyDiscoveries from "./Pages/Journey/Discoveries";
import JourneyDiscoveryRunner from "./Pages/Journey/DiscoveryRunner";
import JourneyCommitments from "./Pages/Journey/Commitments";
import JourneyCommitmentDetail from "./Pages/Journey/Commitments/Detail";
import JourneyProgress from "./Pages/Journey/Progress";
import CaptureHub from "./Pages/Capture";
import CaptureRecord from "./Pages/Capture/Record";
import CaptureDocument from "./Pages/Capture/Document";
import CapturePhoto from "./Pages/Capture/Photo";
import CaptureText from "./Pages/Capture/Text";
import CaptureFlow from "./Pages/Capture/Flow";
import DialogueDetail from "./Pages/Explore/DialogueDetail";
import ExploreLifeArea from "./Pages/Explore/LifeArea";
import ExploreSearch from "./Pages/Explore/search/SearchPage";
import ExploreSelfKnowledge from "./Pages/Explore/SelfKnowledge";
import ExploreMyDialogues from "./Pages/Explore/MyDialogues";
import ExploreActiveDialogues from "./Pages/Explore/ActiveDialoguesPage";
import ExploreResearch from "./Pages/Explore/ResearchPage";

// Admin pages
import AdminDashboard from "./Pages/Admin/AdminDashboard";
import AdminSponsors from "./Pages/Admin/Sponsors/AdminSponsors";
import AdminSponsorDetail from "./Pages/Admin/Sponsors/AdminSponsorDetail";
import AdminContracts from "./Pages/Admin/Contracts/AdminContracts";
import AdminContractDetail from "./Pages/Admin/Contracts/AdminContractDetail";
import AdminInventory from "./Pages/Admin/Inventory/AdminInventory";
import AdminCategories from "./Pages/Admin/Categories/AdminCategories";
import AdminReports from "./Pages/Admin/Reports/AdminReports";
import AdminLayoutShadcn from "./Components/admin/shared/AdminLayoutShadcn";
import AdminCorporatesList from "./Pages/Admin/Corporates/AdminCorporatesList";
import AdminCorporateCreate from "./Pages/Admin/Corporates/AdminCorporateCreate";
import AdminCorporateDetail from "./Pages/Admin/Corporates/AdminCorporateDetail";
import CorporateOverviewTab from "./Pages/Admin/Corporates/tabs/Overview";
import CorporateTabPlaceholder from "./Pages/Admin/Corporates/tabs/Placeholder";
import CorporateDepartmentsTab from "./Pages/Admin/Corporates/tabs/Departments";
import CorporateRolesTab from "./Pages/Admin/Corporates/tabs/Roles";
import CorporateMembersTab from "./Pages/Admin/Corporates/tabs/Members";
import CorporateBrandingTab from "./Pages/Admin/Corporates/tabs/Branding";
import CorporateContentTab from "./Pages/Admin/Corporates/tabs/Content";
import CorporateBenefitsTab from "./Pages/Admin/Corporates/tabs/Benefits";
import CorporateSubscriptionTab from "./Pages/Admin/Corporates/tabs/Subscription";
import CorporateDashboardTab from "./Pages/Admin/Corporates/tabs/Dashboard";
import CorporateCostTab from "./Pages/Admin/Corporates/tabs/Cost";
import AdminPerformance from "./Pages/Admin/Performance/AdminPerformance";
import AdminCost from "./Pages/Admin/Cost/AdminCost";
import AdminEngagement from "./Pages/Admin/Engagement/AdminEngagement";
import AdminResearchLibrary from "./Pages/Admin/ResearchLibrary/AdminResearchLibrary";
import AdminResearchDialogueDetail from "./Pages/Admin/ResearchLibrary/AdminResearchDialogueDetail";
import AdminResearchPulse from "./Pages/Admin/ResearchPulse/AdminResearchPulse";
import AdminResearchPulseDetail from "./Pages/Admin/ResearchPulse/AdminResearchPulseDetail";

// Centralized background wrapper based on route and viewport
const BackgroundWrapper = ({ children, mode = "none" }) => {
  const location = useLocation();
  const path = location.pathname || "";

  const isDesktop = typeof window !== "undefined" ? window.innerWidth > 480 : true;

  // Map routes to background styles
  if (
    path === "/chat" ||
    path.startsWith("/dashboard") ||
    // Journey is a light surface like Explore (Figma 9453:7559 — gray-100 page,
    // white cards) and takes the gradient bucket below, not the blue one.
    path.startsWith("/onboarding") ||
    path.startsWith("/home-v2") ||
    path.startsWith("/home") ||
    path.startsWith("/coach") ||
    path === "/pop-assessment-confirmation" ||
    path.startsWith("/assessmentProgress")
  ) {
    mode = "blue";
  }

  // onboarding-v2 is deprecated - removed
  // Elements page uses Blue but with custom sizing
  if (path === "/elements") {
    mode = "blue-elements";
  }
  // Gradient background routes
  if (
    path.startsWith("/manageRelationship") ||
    path.startsWith("/manageMembership") ||
    path.startsWith("/share-aris") ||
    path.startsWith("/settings") ||
    path === "/voice-preference" ||
    path.startsWith("/faith") ||
    path.startsWith("/connected-health") ||
    path === "/customer-support" ||
    path.startsWith("/explore") ||
    path.startsWith("/journey") ||
    path.startsWith("/capture") ||
    path === "/coachingHistory" ||
    path === "/relationshipProfile" ||
    path === "/myprofile" ||
    path === "/updateSubscriptionPlan"
  ) {
    mode = "gradient";
  }
  // Explicitly avoid global background for signup/login
  if (path.startsWith("/signup") || path === "/" || path === "/login" || path === "/login/email") {
    mode = "none";
  }

  // Enterprise activation pages render their own co-branded chrome — never
  // wrap them in the global background.
  if (path.startsWith("/enterprise/")) {
    mode = "none";
  }

  // Share Aris recipient landing (public, co-branded) — own chrome.
  if (path.startsWith("/share/")) {
    mode = "none";
  }

  // Mobile exceptions where pages intentionally use special mobile layout without gradient
  // Keep exceptions for profile pages, but allow gradient for Coaching History on mobile
  if (!isDesktop && (path === "/relationshipProfile" || path === "/myprofile")) {
    mode = "none";
  }

  if (mode === "blue") {
    return <BlueSvgBackground>{children}</BlueSvgBackground>;
  }
  if (mode === "blue-center") {
    return <BlueSvgBackground flexAlign="center" fullHeight={true}>{children}</BlueSvgBackground>;
  }
  if (mode === "blue-elements") {
    return (
      <BlueSvgBackground fullHeight={false} flexLayout={false}>
        {children}
      </BlueSvgBackground>
    );
  }
  if (mode === "gradient") {
    return <GradientBackground>{children}</GradientBackground>;
  }
  if (mode === "white") {
    return <WhiteBackground>{children}</WhiteBackground>;
  }

  return children;
};

// Voice Preference reuses the Settings page in single-section mode; Faith &
// Spirituality is its own hub + personalization wizard.
const VoicePreferencePage = () => <Settings forcedSection="voice" />;

// `/mission/evolve?…` (the server's deeplink) → the Evolve page, query kept.
const MissionEvolveDeeplink = () => {
  const location = useLocation();
  return <Navigate to={`/journey/mission/evolve${location?.search || ""}`} replace />;
};

// Legacy redirect - now dashboard has its own component
const DashboardRedirect = () => {
  const location = useLocation();
  let mode = "keyboard";
  try {
    const v = localStorage.getItem("coaching_mode");
    if (v === "voice" || v === "keyboard") mode = v;
  } catch (_) {}
  // Voice mode users go to coach, keyboard mode users stay on dashboard
  if (mode === "voice") {
    const search = location?.search || "";
    return <Navigate to={`/coach/private${search}`} replace />;
  }
  // For keyboard mode, redirect to dashboard
  const search = location?.search || "";
  return <Navigate to={`/dashboard${search}`} replace />;
};

// A Share Aris recipient (Companion Membership / Aris Pass) is entitled to Aris
// but never has a subscription of their own — their access is provisioned as
// functionality-access grants tagged `granted_by: "share_aris:<grantId>"` (see
// core-lambda ShareArisService._provision_entitlements). The web-access gate
// below must admit them explicitly on that grant rather than relying on the
// absence of a plan, so companion access survives even if they carry a Guided
// (or any) subscription_cache.
const SHARE_ARIS_GRANT_PREFIX = "share_aris:";

const hasShareArisIn = (functionalities) => {
  if (!functionalities || typeof functionalities !== "object") return false;
  return Object.values(functionalities).some(
    (f) =>
      f?.status === "active" &&
      typeof f?.meta_info?.granted_by === "string" &&
      f.meta_info.granted_by.startsWith(SHARE_ARIS_GRANT_PREFIX)
  );
};

// True when the user holds an active Share Aris grant. Prefers the live
// provider payload; falls back to the cached functionality-access payload so a
// companion isn't briefly blocked before the provider's async fetch resolves.
const hasActiveShareArisGrant = (functionalityAccess) => {
  if (functionalityAccess?.functionalities) {
    return hasShareArisIn(functionalityAccess.functionalities);
  }
  try {
    const cached = JSON.parse(
      localStorage.getItem("functionality_access_cache") || "null"
    );
    return hasShareArisIn(cached?.data?.functionalities);
  } catch (e) {
    return false;
  }
};

// Stale /journey/elements links land on the production Periodic Table page.
// An effect-based redirect (rather than a bare <Navigate>) so it behaves the
// same under every layout/guard wrapper in this router.
const LegacyElementsRedirect = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/elements", { replace: true });
  }, [navigate]);
  return null;
};

const ProtectedRoute = ({ element: Element }) => {
  const location = useLocation();
  const { access: functionalityAccess } = useFunctionalityAccess();

  // Initialize FCM for authenticated users
  useEffect(() => {
    const initializeFCMForAuthenticatedUser = async () => {
      // Check if user is authenticated and FCM is not already initialized
      if (cookies.get("idtoken") && !fcmService.isReady()) {
        try {
          const success = await fcmService.initialize();
          if (success) {
            console.log('FCM initialized for authenticated user in ProtectedRoute');
          }
        } catch (error) {
          console.error('Error initializing FCM in ProtectedRoute:', error);
        }
      }
    };

    // Small delay to ensure the component is fully mounted
    const timeoutId = setTimeout(initializeFCMForAuthenticatedUser, 500);
    
    return () => clearTimeout(timeoutId);
  }, [location.pathname]); // Re-run when route changes

  // Initialize Amplitude for authenticated users
  useEffect(() => {
    if (cookies.get("idtoken")) {
      // Initialize Amplitude with user ID from localStorage
      if (!amplitudeService.isReady()) {
        const userId = amplitudeService.getUserIdFromStorage();
        amplitudeService.initialize(userId);
      } else {
        // Update user ID if profile exists and Amplitude is already initialized
        const userId = amplitudeService.getUserIdFromStorage();
        if (userId && userId !== amplitudeService.userId) {
          amplitudeService.setUserId(userId);
        }
      }

      // Track page view for protected routes
      amplitudeService.trackPageView(location.pathname, {
        route: location.pathname,
        search: location.search,
      });
    }
  }, [location.pathname, location.search]);

  const validPaths = [
    "/ARIS-terms-of-use",
    "/ARIS-about-aris",
    "/ARIS-privacy-policy",
    "/ARIS-cookie-policy",
    "/term-of-use",
    "/about-aris",
    "/privacy-policy",
    "/cookie-policy",
    "/logout"
  ];

  if (
    validPaths.includes(location.pathname)
  ) {
    return (
      <BackgroundWrapper>
        <Element />
      </BackgroundWrapper>
    );
  }

  // Require authentication
  if (!cookies.get("idtoken")) {
    const currentFullPath = `${location.pathname}${location.search || ""}`;
    const redirectParam = encodeURIComponent(currentFullPath);
    return <Navigate to={`/login?redirect_uri=${redirectParam}`} replace />;
  }

  // Check if user has Guided plan and block web access
  const profileRaw = localStorage.getItem("profile");
  let profile = {};
  try {
    profile = profileRaw ? JSON.parse(profileRaw) : {};
  } catch (e) {
    profile = {};
  }

  // Web-access gate. Aris on web is available with a paid plan; the free
  // "Guided" plan is mobile-only and blocked here. Share Aris recipients
  // (Companion Membership / Aris Pass) ARE entitled to the platform but never
  // carry a subscription of their own, so we admit them on their Share Aris
  // grant even if they have a Guided (or no) subscription_cache.
  const subscriptionCache = profile?.meta_info?.subscription_cache;
  if (subscriptionCache && !hasActiveShareArisGrant(functionalityAccess)) {
    const planName = subscriptionCache.plan_name || subscriptionCache.name || '';
    const isGuidedPlan = planName.toLowerCase().includes('guided');

    if (isGuidedPlan) {
      // Block access to all protected routes for Guided plan users
      return (
        <WhiteBackground>
            <GuidedPlanBlockPage />
        </WhiteBackground>
      );
    }
  }

  // Enforce onboarding before allowing protected routes (except signup flow itself)

  // Support multiple possible keys for completed steps from profile
  const completedSteps =
    profile?.onboarding_step ?? profile?.completed_steps ?? profile?.completedSteps ?? [];

  const isInSignupFlow = location.pathname.startsWith("/signup");

  if (!isInSignupFlow) {
    const nextRoute = getOnboardingRoute(completedSteps, profile);
    const complete = isOnboardingComplete(completedSteps);

    // Allow onboarding sub-routes that are part of the flow
    const allowedOnboardingRoutes = ["/onboarding/chat", "/onboarding/instructions", "/onboarding"]; 

    if (!complete) {
      // If user is on an allowed onboarding route, don't force redirect
      if (allowedOnboardingRoutes.includes(location.pathname)) {
        return (
          <BackgroundWrapper>
            <Element />
          </BackgroundWrapper>
        );
      }

      // Otherwise, enforce the computed next route
      if (location.pathname !== nextRoute) {
        return <Navigate to={nextRoute} replace />;
      }
    }
  }

  return (
    <BackgroundWrapper>
      <Element />
    </BackgroundWrapper>
  );
};

// Feature-gated route component
// Wraps ProtectedRoute with additional feature access checks
/**
 * Withholds a route while the member is mid-activation, so a URL cannot reach a
 * section HomeTabBar is deliberately hiding. Wraps ProtectedRoute, so auth and
 * the onboarding redirect still apply first.
 *
 * The member is sent to /dashboard, where activation actually happens.
 */
const ActivationGatedRoute = ({ element: Element }) => {
  const [gatePending, setGatePending] = useState(null);
  const cachedPending = isActivationPending(getCompletedStepsFromStorage());

  // The cached profile can be stale (completion is stamped server-side inside
  // ActivationService.complete(), and nothing rewrites localStorage until the
  // next profile fetch). When the cache says pending, confirm against the authoritative
  // gate — the same posture HomeTabBar takes — and refresh the cached profile
  // so the rest of the app agrees. Gate unavailable (null) = no new
  // information: trust the cache.
  useEffect(() => {
    if (!cachedPending) return undefined;
    let cancelled = false;
    (async () => {
      const pending = await confirmActivationState();
      if (cancelled || pending === null) return;
      setGatePending(pending);
    })();
    return () => {
      cancelled = true;
    };
  }, [cachedPending]);

  // Hold (blank frame, sub-second) while the cache says pending and the gate
  // hasn't answered — redirecting immediately would bounce a freshly-activated
  // member off a tab they can see.
  if (cachedPending && gatePending === null) {
    return null;
  }
  const pending = gatePending ?? cachedPending;
  if (pending) {
    return <Navigate to="/dashboard" replace />;
  }
  return <ProtectedRoute element={Element} />;
};

const FeatureGatedRoute = ({ element: Element, requiredFeature, fallbackPath = "/dashboard" }) => {
  const location = useLocation();
  const { hasFeature, loading, initialized } = useFunctionalityAccess();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (initialized && !loading) {
      setChecked(true);
    }
  }, [initialized, loading]);

  // If no feature requirement, just render the protected route
  if (!requiredFeature) {
    return (
      <BackgroundWrapper>
        <Element />
      </BackgroundWrapper>
    );
  }

  // Wait for functionality access to be loaded
  if (!checked) {
    return (
      <BackgroundWrapper>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <div>Loading...</div>
        </div>
      </BackgroundWrapper>
    );
  }

  // Check if user has access to the required feature
  const hasAccess = hasFeature(requiredFeature);

  if (!hasAccess) {
    // Redirect to fallback path if user doesn't have access
    return <Navigate to={fallbackPath} replace />;
  }

  return (
    <BackgroundWrapper>
      <Element />
    </BackgroundWrapper>
  );
};

// Public routes: if authenticated, redirect to dashboard or appropriate onboarding route
const PublicRoute = ({ element: Element }) => {
  const location = useLocation();

  // If not authenticated, allow access to public pages
  if (!cookies.get("idtoken")) {
    return (
      <BackgroundWrapper>
        <Element />
      </BackgroundWrapper>
    );
  }

  // Let the signup flow manage its own steps and navigation without onboarding redirects
  // This ensures the internal Back button (which moves between step query params) works correctly.
  if (location.pathname.startsWith("/signup")) {
    return (
      <BackgroundWrapper>
        <Element />
      </BackgroundWrapper>
    );
  }

  // If authenticated, check onboarding status and redirect appropriately
  const profileRaw = localStorage.getItem("profile");
  let profile = {};
  try {
    profile = profileRaw ? JSON.parse(profileRaw) : {};
  } catch (_) {
    profile = {};
  }

  const completedSteps =
    profile?.onboarding_step ?? profile?.completed_steps ?? profile?.completedSteps ?? [];
  const isVerified = profile?.is_verified !== false;
  const hasCompletedOnboarding = Array.isArray(completedSteps) && 
    completedSteps.some(s => String(s).toLowerCase() === 'completed');
  const hasSubscription = Array.isArray(completedSteps) && 
    completedSteps.some(s => String(s).toLowerCase() === 'subscription');

  // Check if user has completed onboarding
  if (isVerified && hasCompletedOnboarding && hasSubscription) {
    // If a safe redirect_uri is present, respect it
    const params = new URLSearchParams(location.search || "");
    const redirect = params.get("redirect_uri");
    const isSafePath = (p) => typeof p === "string" && p.startsWith("/") && !p.startsWith("//");
    if (isSafePath(redirect)) {
      return <Navigate to={redirect} replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  // For new/unverified users or incomplete onboarding, redirect to QR page
  // unless they have marketing params, in which case let them through to login flow
  const params = new URLSearchParams(location.search || "");
  const hasPlanParams = params.get('plan') && params.get('subscription_mode');
  
  if (!isVerified || !hasCompletedOnboarding || !hasSubscription) {
    // If no marketing params and user is on login page, redirect to QR
    if (!hasPlanParams && location.pathname === '/login') {
      const queryString = params.toString();
      return <Navigate to={`/login/qr${queryString ? '?' + queryString : ''}`} replace />;
    }
  }

  return (
    <BackgroundWrapper>
      <Element />
    </BackgroundWrapper>
  );
};

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      {
        id: "home",
        text: "Login",
        path: "/",
        element: <PublicRoute element={LoginPage} />,
        errorElement: <div>Error</div>,
      },
      // Public Share Aris recipient landing — no auth required; own chrome.
      // The backend auto-activates on signup/verify (matches invited email/phone).
      {
        id: "share-invite",
        text: "Share Aris Invitation",
        path: "/share/:token",
        element: <ShareInvite />,
        errorElement: <div>Error</div>,
      },
      // Public enterprise activation landing — no auth required.
      // The page has its own auth state (signup token in sessionStorage)
      // and its own co-branded chrome, so it skips ProtectedRoute / PublicRoute
      // entirely.
      {
        id: "enterprise-activation",
        text: "Enterprise Activation",
        path: "/enterprise/:slug",
        element: <CorporateActivation />,
        errorElement: <div>Error</div>,
      },
      {
        id: "enterprise-setup",
        text: "Enterprise Setup",
        path: "/enterprise/:slug/setup",
        element: <CorporateSetup />,
        errorElement: <div>Error</div>,
      },
      {
        id: "enterprise-done",
        text: "Enterprise Done",
        path: "/enterprise/:slug/done",
        element: <CorporateDone />,
        errorElement: <div>Error</div>,
      },
  {
    id: "assessment",
    text: "Assessment",
    path: "/onboarding",
    element: <ProtectedRoute element={Assessments} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "assessmentSaveProgress",
    text: "Assessment-Save Progress",
    path: "/assessmentProgress/:menu",
    element: <ProtectedRoute element={AssessmentSaveProgress} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "assessmentEncouragment",
    text: "Assessment-Encouragement",
    path: "/onboarding/instructions",
    element: <ProtectedRoute element={AssessmentEncouragement} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "assessmentResult",
    text: "Assessment-Result",
    path: "/assessmentResult",
    element: <ProtectedRoute element={AssessmentResult} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "survey",
    text: "survey",
    path: "/survey",
    element: <ProtectedRoute element={Survey} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "new-survey",
    text: "new-survey",
    path: "/onboarding/chat",
    element: <ProtectedRoute element={NewSurvey} />,
    errorElement: <div>New Survey - Error</div>,
  },
  {
    id: "pop-confirmation",
    text: "pop-confirmation",
    path: "/pop-assessment-confirmation",
    element: <ProtectedRoute element={NewConfirmation} />,
    errorElement: <div>confirmation- Error</div>,
  },
  {
    id: "payment-success",
    text: "payment-success",
    path: "/payment-success",
    element: <ProtectedRoute element={Success} />,
    errorElement: <div>payment-success-Error</div>,
  },
  {
    id: "payment-cancel",
    text: "payment-cancel",
    path: "/payment-cancel",
    element: <ProtectedRoute element={Cancel} />,
    errorElement: <div>payment-cancel-Error</div>,
  },
  {
    id: "relationShip",
    text: "Relationship",
    path: "/chat",
    element: <ProtectedRoute element={ChatInterface} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "about-aris",
    text: "About",
    path: "/about-aris",
    element: <ProtectedRoute element={AboutAris} />,
    errorElement: <div>About aris Error</div>,
  },
  {
    id: "ARIS-about-aris",
    text: "About (unprotected)",
    path: "/ARIS-about-aris",
    element: <PublicRoute element={AboutAris} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "ARIS-cookie-policy",
    text: "Cookie Policy",
    path: "/cookie-policy",
    element: <ProtectedRoute element={CookiePolicy} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "term-of-use",
    text: "Terms",
    path: "/term-of-use",
    element: <ProtectedRoute element={TermsofUse} />,
    errorElement: <div>About aris Error</div>,
  },
  {
    id: "ARIS-terms-of-use",
    text: "Terms (unprotected)",
    path: "/ARIS-terms-of-use",
    element: <PublicRoute element={TermsofUse} />,
    errorElement: <div>About aris Error</div>,
  },
  {
    id: "privacy-policy",
    text: "Privacy Policy",
    path: "/privacy-policy",
    element: <ProtectedRoute element={PrivacyPolicy} />,
    errorElement: <div>Privacy policy Error</div>,
  },
  {
    id: "ARIS-privacy-policy",
    text: "Privacy Policy (unprotected)",
    path: "/ARIS-privacy-policy",
    element: <PublicRoute element={PrivacyPolicy} />,
    errorElement: <div>Privacy policy Error</div>,
  },
  {
    id: "customer-support",
    text: "customer-support",
    path: "/customer-support",
    element: <ProtectedRoute element={CustomerSupport} />,
    errorElement: <div>customer-support Error</div>,
  },
  {
    id: "settings",
    text: "settings",
    path: "/settings",
    element: <ProtectedRoute element={Settings} />,
    errorElement: <div>settings Error</div>,
  },
  {
    id: "voice-preference",
    text: "voice-preference",
    path: "/voice-preference",
    element: <ProtectedRoute element={VoicePreferencePage} />,
    errorElement: <div>voice-preference Error</div>,
  },
  {
    id: "faith",
    text: "faith",
    path: "/faith",
    element: <ProtectedRoute element={FaithSpirituality} />,
    errorElement: <div>faith Error</div>,
  },
  {
    id: "connected-health",
    text: "connected-health",
    path: "/connected-health",
    element: <ProtectedRoute element={ConnectedHealth} />,
    errorElement: <div>connected-health Error</div>,
  },
  {
    id: "connected-health-provider",
    text: "connected-health",
    path: "/connected-health/:provider",
    element: <ProtectedRoute element={ConnectedHealthProvider} />,
    errorElement: <div>connected-health Error</div>,
  },
  {
    id: "settings-phone2",
    text: "settings",
    path: "/settings/phone/2",
    element: <ProtectedRoute element={MobilePhoneSettingsScreen2} />,
    errorElement: <div>settings Error</div>,
  },
  {
    id: "Dashboard",
    text: "Dashboard",
    path: "/dashboard",
    element: <ProtectedRoute element={Dashboard} />,
    errorElement: <div>dashboard Error</div>,
  },
  // Home sections. /dashboard stays the "Aris" tab so every existing link and
  // redirect to it keeps working.
  {
    id: "explore",
    text: "Explore",
    path: "/explore",
    element: <ActivationGatedRoute element={Explore} />,
    errorElement: <div>explore Error</div>,
  },
  // DEPRECATED — /dashboard/voice and /dashboard/text.
  //
  // The Aris tab briefly routed here after the Voice/Text chooser. It now starts
  // the conversation on /dashboard itself via `?mode=voice|text`, so nothing in
  // the app links to either path. They are kept only so any bookmark or
  // in-flight link still lands somewhere sensible.
  //
  // TODO: remove both once we are confident no client is hitting them. Deleting
  // them also lets DashboardChat's import here go.
  {
    id: "dashboard-voice",
    text: "Voice session (deprecated)",
    path: "/dashboard/voice",
    element: <ProtectedRoute element={CoachPrivateV2} />,
    errorElement: <div>voice Error</div>,
  },
  {
    id: "dashboard-text",
    text: "Text session (deprecated)",
    path: "/dashboard/text",
    element: <ProtectedRoute element={DashboardChat} />,
    errorElement: <div>text Error</div>,
  },
  // Static explore sub-routes are registered before parameterized siblings, so
  // "self-knowledge" is never captured as a :dialogueId.
  {
    id: "explore-self-knowledge",
    text: "Self-Knowledge",
    path: "/explore/self-knowledge",
    element: <ActivationGatedRoute element={ExploreSelfKnowledge} />,
    errorElement: <div>self knowledge Error</div>,
  },
  {
    id: "explore-search",
    text: "Search",
    path: "/explore/search",
    element: <ActivationGatedRoute element={ExploreSearch} />,
    errorElement: <div>search Error</div>,
  },
  {
    id: "explore-my-dialogues",
    text: "Your Personal Dialogue Library",
    path: "/explore/my-dialogues",
    element: <ActivationGatedRoute element={ExploreMyDialogues} />,
    errorElement: <div>personal dialogues Error</div>,
  },
  {
    id: "explore-active-dialogues",
    text: "Active Dialogues",
    path: "/explore/active-dialogues",
    element: <ActivationGatedRoute element={ExploreActiveDialogues} />,
    errorElement: <div>active dialogues Error</div>,
  },
  {
    id: "explore-research",
    text: "Research Behind This Dialogue",
    path: "/explore/research/:researchDialogueId",
    element: <ActivationGatedRoute element={ExploreResearch} />,
    errorElement: <div>research Error</div>,
  },
  {
    id: "explore-dialogue",
    text: "Dialogue",
    path: "/explore/dialogue/:dialogueId",
    element: <ActivationGatedRoute element={DialogueDetail} />,
    errorElement: <div>dialogue Error</div>,
  },
  {
    id: "explore-life-area",
    text: "Life Area",
    path: "/explore/life-areas/:areaKey",
    element: <ActivationGatedRoute element={ExploreLifeArea} />,
    errorElement: <div>life area Error</div>,
  },
  {
    id: "journey",
    text: "Journey",
    path: "/journey",
    element: <ActivationGatedRoute element={Journey} />,
    errorElement: <div>journey Error</div>,
  },
  // Journey sub-routes. Static segments (mission, momentum, discoveries,
  // elements) are registered before parameterized siblings — same ordering
  // rule as explore-search above.
  {
    id: "journey-mission",
    text: "Mission",
    path: "/journey/mission",
    element: <ActivationGatedRoute element={JourneyMission} />,
    errorElement: <div>journey mission Error</div>,
  },
  // Mission Evolution (v26.3). Static segments before the parameterized ones.
  {
    id: "journey-mission-evolve",
    text: "Evolve your Mission",
    path: "/journey/mission/evolve",
    element: <ActivationGatedRoute element={JourneyMissionEvolve} />,
    errorElement: <div>journey mission evolve Error</div>,
  },
  {
    id: "journey-mission-history",
    text: "Mission History",
    path: "/journey/mission/history",
    element: <ActivationGatedRoute element={JourneyMissionHistory} />,
    errorElement: <div>journey mission history Error</div>,
  },
  {
    id: "journey-mission-history-item",
    text: "Mission",
    path: "/journey/mission/history/:missionId",
    element: <ActivationGatedRoute element={JourneyMissionHistoryItem} />,
    errorElement: <div>journey mission history Error</div>,
  },
  {
    id: "journey-mission-review",
    text: "Your Evolved Mission",
    path: "/journey/mission/review/:draftId",
    element: <ActivationGatedRoute element={JourneyMissionReview} />,
    errorElement: <div>journey mission review Error</div>,
  },
  // The server's deeplink for an Explore "Revisit your Mission" card
  // (`/mission/evolve?entry_source=…`): same page, query kept.
  {
    id: "mission-evolve-deeplink",
    text: "Evolve your Mission",
    path: "/mission/evolve",
    element: <MissionEvolveDeeplink />,
  },
  {
    id: "journey-momentum",
    text: "Momentum",
    path: "/journey/momentum",
    element: <ActivationGatedRoute element={JourneyMomentum} />,
    errorElement: <div>journey momentum Error</div>,
  },
  {
    id: "journey-commitments",
    text: "Your Commitments",
    path: "/journey/commitments",
    element: <ActivationGatedRoute element={JourneyCommitments} />,
    errorElement: <div>journey commitments Error</div>,
  },
  {
    id: "journey-commitment",
    text: "Your Commitment",
    path: "/journey/commitments/:commitmentId",
    element: <ActivationGatedRoute element={JourneyCommitmentDetail} />,
    errorElement: <div>journey commitment Error</div>,
  },
  {
    id: "journey-progress",
    text: "Your Progress",
    path: "/journey/progress",
    element: <ActivationGatedRoute element={JourneyProgress} />,
    errorElement: <div>journey progress Error</div>,
  },
  {
    id: "journey-insight",
    text: "Understanding the Pattern",
    path: "/journey/insight/:insightId",
    element: <ActivationGatedRoute element={JourneyInsight} />,
    errorElement: <div>journey insight Error</div>,
  },
  {
    id: "journey-discoveries",
    text: "Your Discoveries",
    path: "/journey/discoveries",
    element: <ActivationGatedRoute element={JourneyDiscoveries} />,
    errorElement: <div>journey discoveries Error</div>,
  },
  {
    id: "journey-discovery-runner",
    text: "Discovery",
    path: "/journey/discoveries/:discoveryKey/run",
    element: <ActivationGatedRoute element={JourneyDiscoveryRunner} />,
    errorElement: <div>journey discovery Error</div>,
  },
  // The member's Elements live on the production Periodic Table page
  // (/elements). The separate Journey explorer was removed; stale links (and
  // any subpath) land on the canonical view instead of a 404.
  // Capture (DCI): the hub is a home tab; the input screens are static
  // segments registered before the :creationId flow route.
  {
    id: "capture",
    text: "Capture",
    path: "/capture",
    element: <ActivationGatedRoute element={CaptureHub} />,
    errorElement: <div>capture Error</div>,
  },
  {
    id: "capture-record",
    text: "Record Live",
    path: "/capture/record",
    element: <ActivationGatedRoute element={CaptureRecord} />,
    errorElement: <div>capture record Error</div>,
  },
  {
    id: "capture-document",
    text: "Upload a Document",
    path: "/capture/document",
    element: <ActivationGatedRoute element={CaptureDocument} />,
    errorElement: <div>capture document Error</div>,
  },
  {
    id: "capture-photo",
    text: "Upload a Photo",
    path: "/capture/photo",
    element: <ActivationGatedRoute element={CapturePhoto} />,
    errorElement: <div>capture photo Error</div>,
  },
  {
    id: "capture-text",
    text: "Type or Paste Text",
    path: "/capture/text",
    element: <ActivationGatedRoute element={CaptureText} />,
    errorElement: <div>capture text Error</div>,
  },
  {
    id: "capture-flow",
    text: "Capture",
    path: "/capture/:creationId",
    element: <ActivationGatedRoute element={CaptureFlow} />,
    errorElement: <div>capture flow Error</div>,
  },
  {
    id: "journey-elements-redirect",
    text: "Your Elements",
    path: "/journey/elements",
    element: <LegacyElementsRedirect />,
    errorElement: <div>journey elements Error</div>,
  },
  {
    id: "journey-elements-redirect-sub",
    text: "Your Elements",
    path: "/journey/elements/*",
    element: <LegacyElementsRedirect />,
    errorElement: <div>journey elements Error</div>,
  },
  {
    id: "settings-phone3",
    text: "settings",
    path: "/settings/phone/3",
    element: <ProtectedRoute element={MobilePhoneSettingsScreen3} />,
    errorElement: <div>settings Error</div>,
  },
  {
    id: "settings-mail2",
    text: "settings",
    path: "/settings/email/2",
    element: <ProtectedRoute element={EmailSettingPhoneScreen2} />,
    errorElement: <div>settings Error</div>,
  },
  {
    id: "settings-mail3",
    text: "settings",
    path: "/settings/email/3",
    element: <ProtectedRoute element={EmailSettingPhoneScreen3} />,
    errorElement: <div>settings Error</div>,
  },
  {
    id: "settings-notification",
    text: "settings",
    path: "/settings/notification",
    element: <ProtectedRoute element={NotificationSettings} />,
    errorElement: <div>settings Error</div>,
  },
  {
    id: "settings-communication",
    text: "settings",
    path: "/settings/communication",
    element: <ProtectedRoute element={Communications} />,
    errorElement: <div>settings Error</div>,
  },
  {
    id: "loader",
    text: "l",
    path: "/loader",
    element: <Loader />,
    errorElement: <div>settings Error</div>,
  },
  {
    id: "error",
    text: "Error",
    path: "/error/:error",
    element: <ErrorScreen />,
    errorElement: <div>Error</div>,
  },
  {
    id: "login",
    text: "Login",
    path: "/login",
    element: <PublicRoute element={LoginPage} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "login-email",
    text: "Email Login",
    path: "/login/email",
    element: <PublicRoute element={EmailInputPage} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "login-phone",
    text: "Phone Login",
    path: "/login/phone",
    element: <PublicRoute element={PhoneInputPage} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "login-verify-otp",
    text: "Verify OTP",
    path: "/login/verify-otp",
    element: <PublicRoute element={OtpVerificationPage} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "login-qr",
    text: "QR Code",
    path: "/login/qr",
    element: <PublicRoute element={QRCodePage} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "payment-success-qr",
    text: "Payment Success QR",
    path: "/login/payment-success",
    element: <PublicRoute element={PaymentSuccessQRPage} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "apple-callback",
    text: "Apple Callback",
    path: "/auth/apple/callback",
    element: <PublicRoute element={AppleCallbackPage} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "manageRelationship",
    text: "Manage Relationship",
    path: "/manageRelationship",
    element: <ProtectedRoute element={ManageRelationship} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "shareAris",
    text: "Share Aris",
    path: "/share-aris",
    element: <ProtectedRoute element={ShareAris} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "myprofile",
    text: "My Profile",
    path: "/myprofile",
    element: <ProtectedRoute element={MyProfile} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "onboarding",
    text: "Onboarding",
    path: "/onboarding",
    element: <ProtectedRoute element={Onboarding} />,
    errorElement: <div>Error</div>,
  },
  // onboarding-v2 route removed - deprecated, users complete onboarding via mobile app
  {
    id: "feedback",
    text: "feedback",
    path: "/feedback",
    element: <ProtectedRoute element={Feedback} />,
    errorElement: <div>Error</div>,
  },
  // `?activation=true` used to swap in a separate activation screen here. That
  // was the pre-v26 flow (a fixed 90 seconds of audio against
  // /ARIS/voice/activation, an endpoint the backend no longer serves). The
  // first-conversation Activation now runs as an ordinary voice session with
  // dialog_type=activation, chosen from the member's onboarding_step inside the
  // coach screen — so there is nothing left to branch on.
  {
    id: "coach",
    text: "coach",
    path: "/coach/:type",
    element: <ProtectedRoute element={ArisCoach} />,
  },
  {
    id: "coach-private-v2",
    text: "coach-private-v2",
    path: "/coach/private",
    element: <ProtectedRoute element={CoachPrivateV2} />,
  },
  {
    id: "group-coach",
    text: "Group coach",
    path: "/group-coach",
    element: <ProtectedRoute element={ArisCoach} />,
  },
  {
    id: "dialogues-with-id",
    text: "dialogues",
    path: "/dialogues/:relationId",
    element: <ProtectedRoute element={(props) => <UserActivation {...props} relationId={window.location.pathname.split('/').pop()} />} />,
  },
  {
    id: "dialogues",
    text: "dialogues",
    path: "/dialogues",
    element: <ProtectedRoute element={UserActivation} />,
  },
  {
    id: "relationshipProfile",
    text: "Relationship Profile",
    path: "/relationshipProfile",
    element: <ProtectedRoute element={RelationshipProfile} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "coachingHistory",
    text: "Session History",
    path: "/coachingHistory",
    element: <ProtectedRoute element={CoachingHistory} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "manageMembership",
    text: "Manage Membership",
    path: "/manageMembership",
    element: <ProtectedRoute element={ManageMembershipNew} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "elements",
    text: "Elements",
    path: "/elements",
    element: <ProtectedRoute element={Elements} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "home-v2-root",
    text: "Home V2",
    path: "/home-v2",
    element: <ProtectedRoute element={HomeV2Router} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "voice-home-v2",
    text: "Voice Home V2",
    path: "/home-v2/voice",
    element: <ProtectedRoute element={VoiceHomeV2} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "keyboard-home-v2",
    text: "Keyboard Home V2",
    path: "/home-v2/keyboard",
    element: <ProtectedRoute element={KeyboardHomeV2} />,
    errorElement: <div>Error</div>,
  },
  {
    id: "logout",
    text: "Logout",
    path: "/logout",
    element: <ProtectedRoute element={Logout} />,
    errorElement: <div>Error</div>,
  },
  // Admin routes
  {
    id: "admin",
    text: "Admin",
    path: "/admin",
    element: <FeatureGatedRoute element={AdminLayoutShadcn} requiredFeature="ADMIN" />,
    errorElement: <div>Admin Layout Error</div>,
    children: [
      {
        id: "admin-dashboard",
        text: "Admin Dashboard",
        index: true,
        element: <AdminDashboard />,
        errorElement: <div>Admin Dashboard Error</div>,
      },
      {
        id: "admin-sponsors",
        text: "Admin Sponsors",
        path: "sponsors",
        element: <AdminSponsors />,
        errorElement: <div>Admin Sponsors Error</div>,
      },
      {
        id: "admin-sponsor-detail",
        text: "Admin Sponsor Detail",
        path: "sponsors/:id",
        element: <AdminSponsorDetail />,
        errorElement: <div>Admin Sponsor Detail Error</div>,
      },
      {
        id: "admin-contracts",
        text: "Admin Contracts",
        path: "contracts",
        element: <AdminContracts />,
        errorElement: <div>Admin Contracts Error</div>,
      },
      {
        id: "admin-contract-detail",
        text: "Admin Contract Detail",
        path: "contracts/:id",
        element: <AdminContractDetail />,
        errorElement: <div>Admin Contract Detail Error</div>,
      },
      {
        id: "admin-inventory",
        text: "Admin Inventory",
        path: "inventory",
        element: <AdminInventory />,
        errorElement: <div>Admin Inventory Error</div>,
      },
      {
        id: "admin-categories",
        text: "Admin Categories",
        path: "categories",
        element: <AdminCategories />,
        errorElement: <div>Admin Categories Error</div>,
      },
      {
        id: "admin-reports",
        text: "Admin Reports",
        path: "reports",
        element: <AdminReports />,
        errorElement: <div>Admin Reports Error</div>,
      },
      {
        id: "admin-performance",
        text: "Performance",
        path: "performance",
        element: <AdminPerformance />,
        errorElement: <div>Admin Performance Error</div>,
      },
      {
        id: "admin-cost",
        text: "Cost",
        path: "cost",
        element: <AdminCost />,
        errorElement: <div>Admin Cost Error</div>,
      },
      {
        id: "admin-engagement",
        text: "Engagement",
        path: "engagement",
        element: <AdminEngagement />,
        errorElement: <div>Admin Engagement Error</div>,
      },
      // Corporate management
      {
        id: "admin-enterprises",
        text: "Admin Enterprises",
        path: "enterprises",
        element: <AdminCorporatesList />,
        errorElement: <div>Admin Enterprises Error</div>,
      },
      {
        id: "admin-enterprises-new",
        text: "New Enterprise",
        path: "enterprises/new",
        element: <AdminCorporateCreate />,
        errorElement: <div>Admin Enterprise Create Error</div>,
      },
      {
        id: "admin-enterprise-detail",
        text: "Enterprise Detail",
        path: "enterprises/:id",
        element: <AdminCorporateDetail />,
        errorElement: <div>Admin Enterprise Detail Error</div>,
        children: [
          { index: true, element: <CorporateOverviewTab /> },
          { path: "branding", element: <CorporateBrandingTab /> },
          { path: "content", element: <CorporateContentTab /> },
          { path: "departments", element: <CorporateDepartmentsTab /> },
          { path: "roles", element: <CorporateRolesTab /> },
          { path: "members", element: <CorporateMembersTab /> },
          { path: "benefits", element: <CorporateBenefitsTab /> },
          { path: "subscription", element: <CorporateSubscriptionTab /> },
          { path: "dashboard", element: <CorporateDashboardTab /> },
          { path: "cost", element: <CorporateCostTab /> },
        ],
      },
      // Research Dialogue Library
      {
        id: "admin-research-library",
        text: "Admin Research Library",
        path: "research-library",
        element: <AdminResearchLibrary />,
        errorElement: <div>Admin Research Library Error</div>,
      },
      {
        id: "admin-research-dialogue-detail",
        text: "Research Dialogue Detail",
        path: "research-library/:id",
        element: <AdminResearchDialogueDetail />,
        errorElement: <div>Admin Research Dialogue Error</div>,
      },
      // Research Pulse (Coverage Signals: needs no canonical Dialogue covers)
      {
        id: "admin-research-pulse",
        text: "Admin Research Pulse",
        path: "research-pulse",
        element: <AdminResearchPulse />,
        errorElement: <div>Admin Research Pulse Error</div>,
      },
      {
        id: "admin-research-pulse-cluster",
        text: "Research Pulse Cluster",
        path: "research-pulse/:id",
        element: <AdminResearchPulseDetail />,
        errorElement: <div>Admin Research Pulse Cluster Error</div>,
      },
    ],
  },
    ],
  },
]);
